import { render, staticRenderFns } from "./lgtheme.vue?vue&type=template&id=3f77aed4&"
import script from "./lgtheme.vue?vue&type=script&lang=js&"
export * from "./lgtheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports